export default __webpack_public_path__ + "static/media/acceso-camara-windows-4.0a59869d.svg";